
import { EMAIL_LOGIN_FULFILLED, FACEBOOK_LOGIN_FULFILLED } from './login';


let AsyncStorage = window.localStorage;

// Logout action
export const LOGOUT = "LOGOUT";




const initialState = {
  data: null,
  //token: null,
  loggedIn: false,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case EMAIL_LOGIN_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loggedIn: true,
      };

    // case FACEBOOK_LOGIN_FULFILLED:
    //   return {
    //     ...state,
    //     data: action.payload.user,
    //     token: action.payload.token,
    //   };

    case LOGOUT:
      AsyncStorage.removeItem("jwt");
      AsyncStorage.removeItem("refreshToken");
      return initialState;

    default:
      return state;

  }
};




// Logout the user
export function logout() {
  return {
    type: LOGOUT,
  };
}



// WEBPACK FOOTER //
// ./src/modules/user.js